import { render } from "./NewGoalHeader.vue?vue&type=template&id=7b358a1d"
import script from "./NewGoalHeader.vue?vue&type=script&lang=js"
export * from "./NewGoalHeader.vue?vue&type=script&lang=js"
script.render = render

export default script